function AdminService(ApiService) {
  'ngInject';

  const service = {};

  service.newUser  = function(addUserForm, callbackFunc) {
    ApiService.post('/auth/invitation', addUserForm, callbackFunc);
  };

  service.updateUser = function(addUserForm, callbackFunc) {
    ApiService.patch(`/users/${addUserForm.id}.json`,addUserForm, callbackFunc);
  };

  service.deleteUser = function(userId, callbackFunc) {
    ApiService.delete(`/users/${userId}`, {id: userId}, callbackFunc);
  };

  service.listUsers = function (params, callbackFunc) {
    ApiService.get(`/users.json?page=${params.pageNumber}&size=${params.size}&by_name=${params.name}&by_email=${params.email}&by_organization_name=${params.company}&sort=${params.sortBy}`, callbackFunc);
  };

  return service;
}

export default {
  name: 'AdminService',
  fn: AdminService
};
